import {
  UPDATE_REVIEW_START,
  UPDATE_REVIEW_SUCCESS,
  UPDATE_REVIEW_FAILURE,
} from './types';

export const updateReviewStart = (payload) => ({
  type: UPDATE_REVIEW_START,
  payload: payload,
})

export const updateReviewSuccess = (payload) => ({
  type: UPDATE_REVIEW_SUCCESS,
  payload: payload,
})

export const updateReviewFailure = (payload) => ({
  type: UPDATE_REVIEW_FAILURE,
  payload: payload,
})
